/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:100%}.value-cell[_ngcontent-%COMP%]{width:100%;height:100%}.value-cell[_ngcontent-%COMP%] > input[_ngcontent-%COMP%], .value-cell[_ngcontent-%COMP%] > select[_ngcontent-%COMP%]{width:100%;height:100%;text-align:left}.value-cell[_ngcontent-%COMP%] > select[_ngcontent-%COMP%]{padding-left:1px}input[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.icon-fishbone[_ngcontent-%COMP%]{position:relative;right:-30px}\n/*# sourceMappingURL=feat-edit-cell.component.css.map*/"];
export { styles as styles };
